/**
 * BLOCK - PRODUCT BUNDLE NAVIGATION - LISTENERS
 */

setupEventListenersForBundleNavigation();

// Creates the event listeners
function setupEventListenersForBundleNavigation() {  
  // On clicking on a product navigation link
  document.querySelectorAll('[data-action=load-product-bundle-section]').forEach((element) => {
    element.addEventListener('click', loadProductBundleSection);
  });

  // On clicking on a product navigation link
  document.querySelectorAll('[data-action=change-product-slide]').forEach((element) => {
    element.addEventListener('click', changeProductSlide);
  });
}

// On page load
window.addEventListener('DOMContentLoaded', domContentloadedHandler);

/**
 * BLOCK - PRODUCT BUNDLE NAVIGATION - GENERAL
 */

// On dom content loaded
function domContentloadedHandler() {
  triggerSelectedProductChange();
}

// Triggers a change of selected product to update section content
function triggerSelectedProductChange() {
  var bundleNavigationContainers = document.querySelectorAll('.bundle-navigation');
  
  bundleNavigationContainers.forEach((element) => {
    var link = element.querySelector('[data-action=load-product-bundle-section]');

    if (link !== null) {
      if (link.closest('.active') !== null) link.closest('.active').classList.remove('active');
      link.click();
    }
  });
}

// Loads the section with the information of the good product
function loadProductBundleSection() {
  var target = event.currentTarget,
      url = target.getAttribute('href'),
      section = target.closest('.section'),
      sectionClass = section.getAttribute('class').split(' ').pop(),
      sectionBlocks = section.querySelectorAll('.shopify-block');

  event.preventDefault();
  
  if (target.closest('.active') === null) {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        var container = document.createElement('div');
        
        container.innerHTML = text;
        var fetchSection = container.querySelector('.' + sectionClass),
            fetchSectionBlocks = fetchSection.querySelectorAll('.shopify-block'),
            fetchIndex = 0;
    
        if (fetchSection !== null) {
          sectionBlocks.forEach((element, index) => {
            var blockType = element.getAttribute('data-type');
  
            if (blockType.indexOf('product_bundle_navi') == -1) {
              var fetchSectionBlock = fetchSectionBlocks[fetchIndex];
              
              if (fetchSectionBlock !== undefined) {
                element.innerHTML = fetchSectionBlock.innerHTML;
                fetchIndex = fetchIndex + 1;
              }
            }
          });        
  
          selectBundleNavigation(target);
          setupEventListenersForBundleNavigation();
          startCarousels(false);
        }   
      })
      .catch((event) => {
        console.error(event);
      });
  }
}

// Changes the active product slide
function changeProductSlide() {
  var target = event.currentTarget,
      index = parseInt(target.closest('[data-index]').getAttribute('data-index')),
      carousel = target.closest('.carousel');

  event.preventDefault();
  
  if (target.closest('.active') === null) {
    if (isSliderInitialized(carousel)) {
      carousel.swiper.slideTo(index, parseInt(carousel.querySelector('.carousel-wrapper').dataset.speed), false);
      selectBundleNavigation(carousel.querySelector('.swiper-slide-active .bundle-navigation [data-index="' + index + '"]'));
    }
  }
}

// Changes the active navigation
function selectBundleNavigation(target) {
  // Changes the style of the active product image
  var bundleNavigation = target.closest('.bundle-navigation'),
      oldActiveItem = bundleNavigation.querySelector('.active'),
      newActiveItem = target.closest('.bullet-point'),
      newActiveItemIndex = Array.prototype.indexOf.call(bundleNavigation.querySelectorAll('.bullet-point'), newActiveItem),
      bundleNavigationTitle = bundleNavigation.querySelector('.bundle-navigation-title');

  if (oldActiveItem !== null) oldActiveItem.classList.remove('active');
  if (newActiveItem !== null) newActiveItem.classList.add('active');

  // Displays the good active product title
  if (bundleNavigationTitle !== null) {
    var oldActiveTitle = bundleNavigationTitle.querySelector('.bullet-point-text:not(.hidden)'),
        newActiveTitle = bundleNavigationTitle.querySelectorAll('.bullet-point-text')[newActiveItemIndex];
    
    oldActiveTitle.classList.add('hidden');
    newActiveTitle.classList.remove('hidden');
  }
}